
















import Vue from 'vue'
import { createComponent, ref, computed } from '@vue/composition-api'
import TopNav from '../components/TopNav.vue'
import LeftMenu from '../components/LeftMenu.vue'
import FoldTree from '../components/FoldTree.vue'
import OperationBox from '../components/OperationBox.vue'
import isElectron from 'is-electron'
// import { useRouter } from '@/hooks/common'
export default createComponent({
    components: {
        TopNav,
        LeftMenu,
        FoldTree,
        OperationBox
    },
    setup(props,setupContext) {
        const IS_ELECTRON = ref<boolean>(isElectron())
        
        const atPublicPage = computed(()=> {
            // console.log(setupContext.root.$route.path,'path')
            return /public\/*/.test(setupContext.root.$route.path)
        })
        const hasUserDetail=computed(()=>{
            return  setupContext.root.$store.state.isGetUserDetail
        })

        return {
            IS_ELECTRON, 
            atPublicPage,
            hasUserDetail
        }
    }

})
